import { render, staticRenderFns } from "./KnowledgeBaseDetail.vue?vue&type=template&id=3a1a2138"
import script from "./KnowledgeBaseDetail.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseDetail.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeBaseDetail.vue?vue&type=style&index=0&id=3a1a2138&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports